import partnersService from '@/services/partners'

export default {
  namespaced: true,

  state: {
    partnersList: [],
  },

  mutations: {
    setpartnersList(state, list) {
      state.partnersList = list
    },
  },

  actions: {
    fetchpartnersList({ commit }) {
      partnersService.getpartnersList().then(res => {
        commit('setpartnersList', res)
      })
    },
  },
}
